<template>
  <el-dialog title="结算交付"
             :visible.sync="dialogVisible"
             top="10px"
             width="980px"
             custom-class="project-report-dialog"
             :close-on-click-modal="false"
             destroy-on-close
             @closed="progressAfterDialogClosed">
    <el-form class="project-report-form"
             label-position="top">
      <div class="settlement-total-card">
        <div class="settlement-total-card__info">
          <span class="settlement-total-card__icon"><i class="el-icon-s-grid"></i></span>
          <div>
            <div class="settlement-total-card__title">结算总计</div>
            <div class="settlement-total-card__desc">正常结算 + 异常作废</div>
          </div>
        </div>
        <div class="settlement-total-card__amount">
          <span>{{ formatAmount(settlementTotal) }}</span>
          <em>元</em>
        </div>
      </div>
      <div class="settlement-section settlement-section--normal">
        <div class="settlement-section__header">
          <div class="settlement-section__title">
            <span class="settlement-section__icon"><i class="el-icon-success"></i></span>
            <span>正常结算</span>
            <el-tag v-if="form.normal_settled_list.length >= settlementMaxCount"
                    type="danger"
                    size="mini">10/10 已满</el-tag>
          </div>
          <div class="settlement-section__subtotal">小计：<strong>{{ formatAmount(normalSettlementTotal) }}</strong> 元</div>
        </div>
        <div class="settlement-table settlement-table--normal">
          <div class="settlement-table__head">
            <span>结算条目</span>
            <span>单价（元）</span>
            <span>门店数量</span>
            <span>小计（元）</span>
            <span></span>
          </div>
          <div v-for="(item, index) in form.normal_settled_list"
               :key="'normal-' + index"
               class="settlement-table__row">
            <el-input v-model="item.settlement_item"
                      size="small"
                      placeholder="请输入结算条目"></el-input>
            <el-input v-model="item.unit_price"
                      size="small"
                      placeholder="0"
                      @input="recalculateRow(item)"></el-input>
            <el-input v-model="item.store_count"
                      size="small"
                      placeholder="0"
                      @input="recalculateRow(item)"></el-input>
            <span class="settlement-table__amount">{{ item.subtotal || '0' }}</span>
            <el-button type="text"
                       icon="el-icon-delete"
                       @click="removeSettlementRow('normal_settled_list', index)"></el-button>
          </div>
        </div>
        <el-button class="settlement-add-button"
                   size="small"
                   :disabled="form.normal_settled_list.length >= settlementMaxCount"
                   @click="addSettlementRow('normal_settled_list')">
          <i class="el-icon-circle-plus-outline"></i>
          <span v-if="form.normal_settled_list.length >= settlementMaxCount">已达上限（最多10个结算条目）</span>
          <span v-else>添加结算条目</span>
        </el-button>
      </div>
      <div class="settlement-section settlement-section--abnormal">
        <div class="settlement-section__header">
          <div class="settlement-section__title">
            <span class="settlement-section__icon"><i class="el-icon-warning"></i></span>
            <span>异常作废</span>
            <el-tag v-if="form.abnormal_voided_list.length >= settlementMaxCount"
                    type="danger"
                    size="mini">10/10 已满</el-tag>
          </div>
          <div class="settlement-section__subtotal">小计：<strong>{{ formatAmount(abnormalSettlementTotal) }}</strong> 元</div>
        </div>
        <div class="settlement-table settlement-table--abnormal">
          <div class="settlement-table__head">
            <span>结算条目</span>
            <span>单价（元）</span>
            <span>门店数量</span>
            <span>小计（元）</span>
            <span></span>
          </div>
          <div v-for="(item, index) in form.abnormal_voided_list"
               :key="'abnormal-' + index"
               class="settlement-table__row">
            <el-input v-model="item.settlement_item"
                      size="small"
                      placeholder="请输入结算条目"></el-input>
            <el-input v-model="item.unit_price"
                      size="small"
                      placeholder="0"
                      @input="recalculateRow(item)"></el-input>
            <el-input v-model="item.store_count"
                      size="small"
                      placeholder="0"
                      @input="recalculateRow(item)"></el-input>
            <span class="settlement-table__amount">{{ item.subtotal || '0' }}</span>
            <el-button type="text"
                       icon="el-icon-delete"
                       @click="removeSettlementRow('abnormal_voided_list', index)"></el-button>
          </div>
        </div>
        <el-button class="settlement-add-button"
                   size="small"
                   :disabled="form.abnormal_voided_list.length >= settlementMaxCount"
                   @click="addSettlementRow('abnormal_voided_list')">
          <i class="el-icon-circle-plus-outline"></i>
          <span v-if="form.abnormal_voided_list.length >= settlementMaxCount">已达上限（最多10个结算条目）</span>
          <span v-else>添加结算条目</span>
        </el-button>
      </div>
      <el-form-item label="备注">
        <el-input v-model="form.file_remarks"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入备注内容"
                  maxlength="500"
                  show-word-limit>
        </el-input>
      </el-form-item>
      <el-form-item label="文件上传">
        <el-upload ref="uploadRef"
                   class="project-report-upload no-transition-upload"
                   action=""
                   :auto-upload="false"
                   :on-change="handleFileChange"
                   drag
                   list-type="text">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text"
               style="font-size: 12px;line-height: 1.2;">
            将文件拖到此处，或<em>点击上传</em><br>
            文件多于20个时建议上传zip压缩文件
          </div>
          <template slot="file"
                    slot-scope="{ file }">
            <div class="upload-file-item">
              <a class="upload-file-link"
                 href="javascript:void(0)"
                 @click.prevent.stop="downloadProgressAttachFile(file)">
                {{ file.name }}</a>
              <i class="el-icon-download"
                 style="margin-right: 6px;cursor: pointer;"
                 @click="downloadProgressAttachFile(file)"></i>
              <i class="el-icon-delete"
                 style="cursor: pointer;"
                 @click="removeFile(file)"></i>
            </div>
          </template>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary"
                 @click="onSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import userWorkInfoMixin from '@views/user-workinfo/user-workinfo.mixin.js'
import projectMixins from '@views/project/project.mixins'
import {
  buildProjectReportSubmitParams,
  createSettlementRow,
  hydrateProjectReportForm,
  recalculateSettlementRow,
  sumSettlementSubtotal,
} from '@views/project/project-report-settlement'

export default {
  mixins: [userWorkInfoMixin, projectMixins],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: String,
      default: '0',
    },
    fullNode: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      settlementMaxCount: 10,
      form: hydrateProjectReportForm(),
    }
  },
  computed: {
    ...Vuex.mapState({
      loginUser: state => state.login.user,
    }),
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      },
    },
    normalSettlementTotal () {
      return sumSettlementSubtotal(this.form.normal_settled_list)
    },
    abnormalSettlementTotal () {
      return sumSettlementSubtotal(this.form.abnormal_voided_list)
    },
    settlementTotal () {
      return this.normalSettlementTotal + this.abnormalSettlementTotal
    },
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.initAttr(this.fullNode.project_node || {})
        }
      },
      immediate: true,
    },
  },
  methods: {
    formatAmount (value) {
      const numberValue = Number(value) || 0
      return numberValue.toLocaleString('zh-CN', {maximumFractionDigits: 2})
    },
    initAttr (projectNode) {
      this.form = hydrateProjectReportForm(_.get(projectNode, 'node_result', {}))
      this.$nextTick(() => {
        if (!this.$refs.uploadRef) return
        this.$refs.uploadRef.uploadFiles = this.form.project_report_files.map(f => ({
          name: f.name,
          url: f.url,
          status: 'success',
          uid: f.uid || Date.now() + Math.random(),
        }))
      })
    },
    recalculateRow (row) {
      Object.assign(row, recalculateSettlementRow(row))
    },
    addSettlementRow (listKey) {
      if (this.form[listKey].length >= this.settlementMaxCount) {
        this.$message.warning('每种结算类型最多添加10个')
        return
      }
      this.form[listKey].push(createSettlementRow())
    },
    removeSettlementRow (listKey, index) {
      this.form[listKey].splice(index, 1)
    },
    validateBeforeSubmit () {
      if (this.settlementTotal <= 0) {
        this.$message.error('结算总计必须大于0')
        return false
      }
      if (this.form.normal_settled_list.length > this.settlementMaxCount ||
        this.form.abnormal_voided_list.length > this.settlementMaxCount) {
        this.$message.error('每种结算类型最多添加10个')
        return false
      }

      const isAllValid = this.form.normal_settled_list.every(item => {
        return Object.values(item).every(value => !!value)
      })

      const isAllValid2 = this.form.abnormal_voided_list.every(item => {
        return Object.values(item).every(value => !!value)
      })

      if (!isAllValid || !isAllValid2) {
        this.$message.error('请完善所有结算信息')
        return
      }
      return true
    },
    buildSubmitParams () {
      return buildProjectReportSubmitParams(this.projectId, this.form)
    },
    async handleFileChange (file) {
      try {
        await this.withLoading(async () => {
          const url = await this.doAdminDirectUploadFile(file.raw)
          if (url) {
            file.url = url
            this.form.project_report_files.push(this.formatStandardFile(file, this.loginUser))
          } else {
            this.$refs.uploadRef.handleRemove(file)
          }
        }, '文件上传中...')
      } catch (e) {
        this.$message.error('添加至文件列表失败，原因: ' + e)
        this.$refs.uploadRef.handleRemove(file)
      }
    },
    async removeFile (file) {
      try {
        await this.$confirm(`确定要移除文件【${file.name}】吗？`, '移除文件警告')
        this.$refs.uploadRef.handleRemove(file)
        const index = this.form.project_report_files.findIndex(f => f.name === file.name && f.url === file.url)
        if (index > -1) {
          this.form.project_report_files.splice(index, 1)
        }
      } catch (e) {
      }
    },
    async onSubmit () {
      if (!this.validateBeforeSubmit()) return
      const params = this.buildSubmitParams()
      await this.withLoading(async () => {
        try {
          const res = await request.common('uploadProjectReportApi', params)
          this.progressDialogAfterSubmitSuccess(res.data)
          this.$message.success('结算交付数据保存成功')
        } catch (error) {
          this.$message.error(error.message || '保存失败')
        }
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
.project-report-form {
  padding: 0 2px;

  /deep/ .el-form-item__label {
    padding-bottom: 8px;
    color: #1f2937;
    font-weight: 600;
  }
}

.settlement-total-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 92px;
  padding: 0 28px;
  margin-bottom: 22px;
  border: 1px solid #d7e7ff;
  border-radius: 8px;
  background: #edf4ff;
}

.settlement-total-card__info {
  display: flex;
  align-items: center;
}

.settlement-total-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-right: 16px;
  color: #fff;
  font-size: 24px;
  border-radius: 8px;
  background: #2f73f6;
}

.settlement-total-card__title {
  color: #667085;
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
}

.settlement-total-card__desc {
  color: #8a96a8;
  font-size: 13px;
  line-height: 22px;
}

.settlement-total-card__amount {
  color: #2f66e8;
  font-size: 36px;
  font-weight: 700;
  line-height: 1;
}

.settlement-total-card__amount em {
  margin-left: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}

.settlement-section {
  margin-bottom: 24px;
  overflow: hidden;
  border: 1px solid #dde8df;
  border-radius: 8px;
}

.settlement-section--normal {
  border-color: #d7f0dd;
}

.settlement-section--abnormal {
  border-color: #f3dfcb;
}

.settlement-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 62px;
  padding: 0 20px;
}

.settlement-section--normal .settlement-section__header {
  background: #eefbf2;
}

.settlement-section--abnormal .settlement-section__header {
  background: #fff5e8;
}

.settlement-section__title {
  display: flex;
  align-items: center;
  color: #1f2937;
  font-size: 16px;
  font-weight: 700;
}

.settlement-section__title > * {
  margin-right: 10px;
}

.settlement-section__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: #fff;
  border-radius: 4px;
}

.settlement-section--normal .settlement-section__icon {
  background: #21c76a;
}

.settlement-section--abnormal .settlement-section__icon {
  background: #ff7a1a;
}

.settlement-section__subtotal {
  color: #606f82;
  font-size: 15px;
}

.settlement-section__subtotal strong {
  margin: 0 6px;
  font-size: 24px;
}

.settlement-section--normal .settlement-section__subtotal strong {
  color: #009966;
}

.settlement-section--abnormal .settlement-section__subtotal strong {
  color: #f04b13;
}

.settlement-table {
  padding: 0 20px 16px;
}

.settlement-table__head,
.settlement-table__row {
  display: grid;
  grid-template-columns: minmax(240px, 1fr) 130px 130px 110px 36px;
  column-gap: 8px;
  align-items: center;
}

.settlement-table__head {
  height: 40px;
  color: #667085;
  font-size: 13px;
  font-weight: 700;
}

.settlement-table__row {
  margin-bottom: 10px;
}

.settlement-table__amount {
  text-align: right;
  font-weight: 700;
}

.settlement-table--normal .settlement-table__amount {
  color: #009966;
}

.settlement-table--abnormal .settlement-table__amount {
  color: #f04b13;
}

.settlement-add-button {
  width: calc(100% - 40px);
  margin: 0 20px 14px;
  color: #8a96a8;
  border-style: solid;
  background: #fafbfc;
}

.project-report-upload {
  width: 360px;
}

.project-report-upload /deep/ .el-upload-dragger {
  width: 360px;
  height: 150px;
}

.upload-file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.upload-file-link {
  color: #409eff;
  text-decoration: none;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}
</style>

<style lang="scss">
.project-report-dialog .el-dialog__body {
  padding: 22px 28px 12px;
}

.no-transition-upload .el-upload-list__item,
.no-transition-upload .el-list-enter-active,
.no-transition-upload .el-list-leave-active {
  transition: none !important;
}

.no-transition-upload .el-list-enter,
.no-transition-upload .el-list-leave-to {
  opacity: 1 !important;
  transform: none !important;
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/project/components/UploadProjectReportDialog.vue